import LoaderMain from 'components/shared/LoaderMain';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

const FlightBookSkeleton: FC = () => {
    return (
  <>
      <div className="details book">
        <div className="book-form default-shadow">
          <div className="title-underline text-lg mb-20">
            <Skeleton width={320} />
          </div>
          <div>
            {[...Array(2)].map((_, index) => (
              <div className="book-form-room" key={index}>
                <div className="title text-md mb-15">
                  <span className="mr-5">
                    <Skeleton width={200} />
                  </span>

                  <span className="text-sm text-light text-normal">
                    <Skeleton width={300} />
                  </span>
                </div>
                <div className="form-wrapper row">
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="title text-md mb-15">
            <Skeleton width={200} />
          </div>
          <div className="book-payment mb-20">
            <div className="title text-md mb-20 mt-10">
              <Skeleton height={30} />
            </div>
            <div className="form-wrapper row">
              <div className="col-md-3 col-12">
                <Skeleton width={'100%'} height={38} className="mb-5" />
              </div>
              <div className="col-md-6 col-12">
                <Skeleton width={'50%'} height={38} className="mb-5" />
              </div>
              <div className="col-md-3 col-12">
                <Skeleton width={120} height={38} className="mb-5" />
              </div>
            </div>
            <div className="flex-between form-wrapper row">
              <div className="col-12 col-md-9">
                <Skeleton width={220} height={30} className="mb-5" />
              </div>

              <div className="col-md-3 col-12">
                <Skeleton width={120} height={38} className="mb-5" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="details-summary book-summary default-shadow flight-details-summary">
        <div className="title-underline text-lg mb-20">
          <Skeleton width={200} />
        </div>

        <div className="title text-st text-contrast">
          <Skeleton width={150} />
        </div>

        {[...Array(2)].map((_, index) => (
          <div className="summary" key={index}>
            <span className="summary-img">
              <Skeleton height={80} width={120} />
            </span>
            <div className="mb-10 text-center">
              <Skeleton width={200} />
            </div>

            <div className="summary-road">
              <div className="summary-road-item">
                <div>
                  <span>
                    <Skeleton width={120} />
                  </span>
                  <br />
                  <Skeleton width={100} />
                </div>
                <div>
                  <Skeleton width={160} />
                </div>
              </div>
              <div className="summary-road-item">
                <div>
                  <span>
                    <Skeleton width={130} />
                  </span>
                  <br />
                  <span className="text-light text-xxs">
                    <Skeleton width={120} />
                  </span>
                </div>
                <div>
                  <Skeleton width={160} />
                </div>
              </div>
            </div>
          </div>
        ))}
        <div className="divider mb-20"></div>
        <div className="title text-st text-contrast">
          <Skeleton width={120} />
        </div>
        <div className="text-sm mb-20 text-lh-sm">
          <Skeleton width={120} />
        </div>
        <div className="divider mb-20"></div>
        <div className="flex-between mb-10">
          <div className="title text-st text-contrast">
            <Skeleton width={140} />
          </div>
          <span className="text-bold text-md">
            <Skeleton width={120} />
          </span>
        </div>

        {[...Array(2)].map((_, index) => (
          <div className="mb-10" key={index}>
            <span className="flex-between">
              <span>
                <Skeleton width={140} />
              </span>
              <span>
                <Skeleton width={120} />
              </span>
            </span>
          </div>
        ))}
        <div className="mt-20 flex-between text-lg text-bold">
          <Skeleton width={200} />
          <span className="text-contrast">
            <Skeleton width={120} />
          </span>
        </div>
      </div>
      <LoaderMain systemProducts="Flights" systemProductsDetails="LoadingBook" />
  </>
  );
};

export default FlightBookSkeleton;
